import _ from "@/boot/lodash";

export function getNewValues(form, formClone) {
  return _.omitBy(form, (v, k) => {
    return formClone[k] === v;
  });
}
